<style scoped lang="scss">

</style>
<template>
    <div class="container">
        <cpnpeceiptor></cpnpeceiptor>
    </div>
</template>

<script>
    import cpnpeceiptor from '@/views/frontend/components/receiptor.vue';
    export default {
        name: 'receiptor',
        components:{
            cpnpeceiptor
        }
    }
</script>


